import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: 'reviewImg',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      client: 'CLIENT/client',
    }),
  }
}
